<template>
  <div
    v-show="show"
    class="border relative empty:hidden text-xs leading-[1.125rem]"
    :class="[
      component.size,
      component.main,
      component.width,
      customClass
    ]"
  >
    <p
      v-if="$slots.title"
      class="text-base mb-1 font-bold"
    >
      <slot name="title" />
    </p>

    <slot v-if="$slots.default" />

    <img
      v-if="hasClose"
      ref="icon"
      src="/icons/close-cirle.svg"
      alt="close circle"
      class="absolute top-[0.5625rem] right-[0.5625rem] cursor-pointer"
      @click="show = false"
    />
  </div>
</template>

<script setup>
defineOptions({
  name: 'AtomsAlert'
})

const props = defineProps({
  size: {
    type: String,
    default: 'p1',
    validator: value => ['p1', 'p2', 'p'].includes(value)
  },

  type: {
    type: String,
    default: 'error',
    validator: value => ['info', 'warning', 'error', 'success', 'disclaimer'].includes(value)
  },

  hasClose: {
    type: Boolean,
    default: false
  },

  fullWidth: {
    type: Boolean,
    default: false
  },

  rounded: {
    type: Boolean,
    default: true
  },

  customClass: {
    type: String,
    default: ''
  }
})

const show = ref(true)

defineExpose({
  show
})

// styles
const component = computed(() => {
  return {
    size: getKey(props.size, {
      p: `py-0 px-2 ${props.hasClose ? 'pr-10' : ''}`,
      p1: `p-2 ${props.hasClose ? 'pr-10' : ''}`,
      p2: `p-4 ${props.hasClose ? 'pr-8' : ''}`
    }),

    main: (() => {
      const base = getKey(props.type, {
        info: 'bg-semantic-states-info-variant text-semantic-surface-on-surface',
        error: 'bg-semantic-states-error-variant text-semantic-surface-on-surface',
        warning: 'bg-semantic-states-warning-variant text-semantic-surface-on-surface',
        success: 'bg-semantic-states-success-variant text-semantic-surface-on-surface',
        disclaimer: 'bg-semantic-surface-default text-semantic-surface-on-surface'
      })

      const border = getKey(props.type, {
        info: 'border-semantic-states-info-default',
        error: 'border-semantic-states-error-default',
        warning: 'border-semantic-states-warning-default',
        success: 'border-semantic-states-success-default',
        disclaimer: 'border-semantic-outline-default'
      })

      return `${base} ${border} ${props.rounded ? 'rounded-lg' : ''}`
    })(),

    width: (() => {
      if (props.fullWidth) {
        return 'w-full'
      }

      return 'w-full max-w-[26.5rem] sm:max-w-[28.125rem]'
    })()
  }
})
</script>
